export const AUTH = {
  // Agent
  loginPage: "agent-login-page",
  loginEmail: "agent-login-email",
  loginPassword: "agent-login-password",
  loginSubmit: "agent-login-submit",
  loginError: "agent-login-error",
  dashboard: "agent-dashboard",
  logoutBtn: "agent-logout-btn",
  leadsTable: "leads-table",
  leadRow: "lead-row",
  // Merchant
  merchantLoginPage: "merchant-login-page",
  merchantLoginEmail: "merchant-login-email",
  merchantLoginPassword: "merchant-login-password",
  merchantLoginSubmit: "merchant-login-submit",
  merchantLoginError: "merchant-login-error",
  merchantDashboard: "merchant-dashboard",
  merchantStatusBadge: "merchant-status-badge",
  merchantDocsList: "merchant-docs-list",
  merchantMessages: "merchant-messages",
  merchantMessageInput: "merchant-message-input",
  merchantMessageSend: "merchant-message-send",
  merchantLogout: "merchant-logout-btn",
};
